import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import parse from "html-react-parser";
import { yupResolver } from "@hookform/resolvers/yup";
import { Link, useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import { Controller, useForm } from "react-hook-form";
import registerCareersSchema from "../validationSchemas/CareersSchema";
import Banner from "../assets/get-demo-section-bg.jpg";

function DemoInterestedSectionCareers({ data }) {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [fileName, setFileName] = useState("Upload File");
  const form = useRef();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(registerCareersSchema),
  });

  const onSubmit = (formData) => {
    const payload = new FormData();
    payload.append("name", formData.name);
    payload.append("email", formData.email);
    payload.append("phone", formData.phone);

    // Check if a file exists and append only if it does
    if (formData.attachment && formData.attachment.length > 0) {
      payload.append("attachment", formData.attachment[0]);
    }

    fetch(
      "https://www.lagunacreek.io/blog/wp-json/custom-api/v1/career-form",
      {
        method: "POST",
        body: payload,
      }
    )
      .then((res) => {
        if (!res.ok) throw new Error("Failed");
        return res.json();
      })
      .then((data) => {
        console.log("Success:", data);
        navigate("/thank-you");
      })
      .catch((err) => {
        console.error("Error:", err);
        alert("Submission failed.");
      });
  };

  const handleButtonClick = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const heading = data?.interested_in_joining_us || "Interested in joining us?";
  const subheading =
    data?.just_attached_your_resume_below_and_well_be_in_touch ||
    "Just attach your resume below and we'll be in touch!";

  const box1 = data?.interested_in_joining_box?.[0];
  const box2 = data?.interested_in_joining_box?.[1];

  return (
    <>
      <section
        id="interestedBox"
        className="py-[54px] mx-auto bg-no-repeat bg-cover bg-center"
        style={{
          backgroundImage: `url(${Banner})`,
        }}
      >
        <div className="w-full max-w-[1570px] px-4 mx-auto">
          <div className="flex flex-wrap -mx-4 gap-y-8 lg:gap-y-11">
            <div className="w-full max-w-full px-4">
              <div className="max-w-[894px] mx-auto text-center">
                <h2 className="text-[30px] md:text-[40px] lg:text-[52px] font-normal leading-none text-white mb-3">
                  {heading}
                </h2>
                <p className="text-lg font-light leading-7 text-white">
                  {subheading}
                </p>
              </div>
            </div>
            <div className="w-full lg:w-1/2 max-w-full px-4">
              <div className="p-6 sm:p-10 rounded-[21px] bg-white h-full">
                {box1?.interested_in_joining_box_detail ? (
                  parse(box1.interested_in_joining_box_detail)
                ) : (
                  <>
                    <h3 className="text-2xl font-normal leading-7 text-[#23232D]">
                      Don't see the perfect job opening but think you'd still be
                      a great fit for our team?
                    </h3>
                    <h3 className="text-2xl font-normal leading-7 text-[#23232D]">
                      Just upload and send your resume below and we'll be in
                      touch!
                    </h3>
                  </>
                )}
                <button
                  onClick={handleButtonClick}
                  className="inline-block text-xs font-normal leading-6 text-[#5fa3b2] border border-[#5fa3b2] bg-white py-2 px-9 rounded-[12px] transition-all ease-in-out duration-500 hover:text-white hover:bg-[#5fa3b2] w-full text-center"
                >
                  {box1?.interested_in_joining_box_button_text ||
                    "Or Just attach your resume and we'll be in touch 11"}
                </button>
              </div>
            </div>

            <div className="w-full lg:w-1/2 max-w-full px-4">
              <div className="p-6 sm:p-10 rounded-[21px] bg-white h-full">
                <div className="flex flex-wrap justify-between gap-x-8 gap-y-16">
                  {box2?.interested_in_joining_box_detail ? (
                    parse(box2.interested_in_joining_box_detail)
                  ) : (
                    <>
                      <div className="w-auto">
                        <h3 className="text-2xl font-normal leading-7 text-[#23232D]">
                          Company
                        </h3>
                      </div>
                      <div className="w-auto">
                        <span className="block text-lg font-light leading-7 text-[#333333]">
                          Laguna Creek, LLC
                        </span>
                        <a
                          className="text-lg font-light leading-7 text-[#333333] transition-all ease-in-out duration-500 hover:text-[#faa42a]"
                          href="https://maps.app.goo.gl/9gu2YqZUbuyhJpva9"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <span className="block">
                            971 N Gilbert Rd STE #315
                          </span>
                          <span className="block">Gilbert, AZ 85234</span>
                        </a>
                        <a
                          href="tel:+16233002434"
                          className="text-lg font-light leading-7 text-[#333333] transition-all ease-in-out duration-500 hover:text-[#faa42a]"
                        >
                          <span className="block">(623) 300-2434</span>
                        </a>
                      </div>
                    </>
                  )}
                  {box2?.interested_in_joining_box_button_url && (
                    <Link
                      to={box2.interested_in_joining_box_button_url}
                      className="inline-block text-xs font-normal leading-6 text-[#5fa3b2] border border-[#5fa3b2] bg-white py-2 px-9 rounded-[12px] transition-all ease-in-out duration-500 hover:text-white hover:bg-[#5fa3b2] w-full text-center"
                    >
                      {box2?.interested_in_joining_box_button_text ||
                        "Contact Us"}
                    </Link>
                  )}
                </div>
              </div>
            </div>

            {isPopupOpen && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="bg-[#B35526] py-8 px-8 md:px-12 rounded-[21px] max-w-[500px] w-full shadow-lg mx-4">
                  <div className="text-right">
                    <button onClick={closePopup} className="text-white">
                      X
                    </button>
                  </div>
                  <h2 className="text-[30px] md:text-[40px] lg:text-[48px] font-normal leading-[1.3542] text-white">
                    Upload Resume
                  </h2>
                  <p className="text-lg font-light leading-[1.667] text-white mb-8">
                    We'll be in touch with you!
                  </p>
                  <form ref={form} onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-8">
                      <div className="relative">
                        <label className="text-base font-bold leading-none text-white tracking-[0.3px] px-2.5 bg-[#B35526] absolute -top-[9px] left-[15px]">
                          Full Name
                        </label>
                        <input
                          {...register("name")}
                          type="text"
                          className="block w-full text-base font-light leading-none text-white bg-transparent py-[19px] px-[25px] rounded-[10px] border border-[#F1F1F1] tracking-[0.3px] focus:outline-none placeholder:text-[rgba(245,245,245,0.5)]"
                          placeholder="Enter your full name"
                        />
                        {errors.name && (
                          <p className="text-sm font-light text-[#FFF] mt-1">
                            {errors.name.message}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="mb-8">
                      <div className="relative">
                        <label className="text-base font-bold leading-none text-white tracking-[0.3px] px-2.5 bg-[#B35526] absolute -top-[9px] left-[15px]">
                          Email
                        </label>
                        <input
                          {...register("email")}
                          type="email"
                          className="block w-full text-base font-light leading-none text-white bg-[transparent] py-[19px] px-[25px] rounded-[10px] border border-[#F1F1F1] tracking-[0.3px] focus:outline-none placeholder:text-[rgba(245,245,245,0.5)]"
                          placeholder="Enter your email address"
                        />
                        {errors.email && (
                          <p className="text-sm font-light text-[#FFF] mt-1">
                            {errors.email.message}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="mb-8">
                      <div className="relative">
                        <label className="text-base font-bold text-white px-2.5 bg-[#B35526] absolute -top-[9px] left-[15px] z-10">
                          Phone number
                        </label>
                        <Controller
                          name="phone"
                          control={control}
                          rules={{ required: "Phone number is required" }}
                          render={({
                            field: { onChange, onBlur, value, name, ref },
                          }) => (
                            <PhoneInput
                              country={"us"}
                              enableSearch={true}
                              value={value}
                              onChange={onChange}
                              inputProps={{
                                name,
                                required: true,
                                onBlur,
                                ref,
                                className:
                                  "w-full text-white bg-transparent py-[19px] pl-[75px] pr-[19px] rounded-[10px] border border-[#F1F1F1] focus:outline-none placeholder:text-[rgba(245,245,245,0.5)]",
                              }}
                            />
                          )}
                        />
                        {errors.phone && (
                          <p className="text-sm text-[#FFF] mt-1">
                            {errors.phone.message}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="mb-8">
                      <Controller
                        name="attachment"
                        control={control}
                        defaultValue={[]}
                        render={({ field }) => (
                          <>
                            <input
                              id="file-upload"
                              type="file"
                              accept=".pdf,.doc,.docx"
                              className="hidden"
                              onChange={(e) => {
                                const file = e.target.files;
                                field.onChange(file); // MUST pass FileList or array
                                setFileName(
                                  file.length > 0 ? file[0].name : "Upload File"
                                );
                              }}
                            />
                            <label
                              htmlFor="file-upload"
                              className="inline-block text-xs font-normal leading-6 text-[#fff] border border-[#fff] py-2 px-9 rounded-[12px] transition-all ease-in-out duration-500 hover:text-white hover:bg-[#5fa3b2] w-full text-center cursor-pointer"
                            >
                              {fileName}
                            </label>
                          </>
                        )}
                      />
                      {errors.attachment && (
                        <p className="text-sm text-[#FFF] mt-1">
                          {errors.attachment.message}
                        </p>
                      )}
                    </div>
                    <div className="mb-0">
                      <button
                        type="submit"
                        className="block w-full text-lg font-bold leading-6 text-[#111111] bg-white border border-white py-[17px] px-[17px] md:px-[35px] rounded-[7px] transition-all ease-in-out duration-500 text-center hover:text-white hover:bg-[#5FA3B2] hover:border-[#5FA3B2]"
                      >
                        Send
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default DemoInterestedSectionCareers;
